import { LookUpRecord, UserRecord } from "src/types/main";
import { LookupFields, UserFields } from "src/modules/modules.type";
import { FIELDS_TYPES } from "./type.config";
import { Moment } from "moment";

export const notificationStatusesListName = "NotificationStatuses";
export const notificationIdsListName = "NotificationIds";
export const getNotificationsListName = "GetNotifications";
export const sendNotificationsListName = "SendNotifications";
export const notificationsListName = "Notifications";
export const notificationsCardListName = "NotificationsCard";
export const templatesOWDListName = "TemplatesOWD";
export const templateOWDQuestionListName = "TemplateOWDQuestion";
export const templateOWDQuestionsListName = "TemplateOWDQuestions";

export const checkListOWDIdsListName = "CheckListOWDIds";
export const checkListsOWDListName = "CheckListsOWD";

export const notificationTestsAnswers = "NotificationTestsAnswers";
export const notificationTestsQuestion = "NotificationTestsQuestion";
export const notificationTests = "NotificationTests";
export const notificationTestResult = "NotificationTestResult";
export const testRegistry = "TestRegistry";
export const answersRegistry = "AnswersRegistry";
export const questionsRegistry = "QuestionsRegistry";

export const notificationsListFields = {
  [answersRegistry]: {
    ID: FIELDS_TYPES.ID,
    Description: FIELDS_TYPES.STRING,
    IsCorrect: FIELDS_TYPES.BOOLEAN,
    Title: FIELDS_TYPES.STRING,
  },
  [questionsRegistry]: {
    ID: FIELDS_TYPES.ID,
    Description: FIELDS_TYPES.STRING,
    TypeQuestion: FIELDS_TYPES.STRING,
    Answers: FIELDS_TYPES.MULTI_LOOKUP,
    Title: FIELDS_TYPES.STRING,
  },
  [testRegistry]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    QuestionsID: FIELDS_TYPES.MULTI_LOOKUP,
    Collections: FIELDS_TYPES.LOOKUP,
    MinCorrectAnswerCount: FIELDS_TYPES.NUMBER,
  },

  [notificationTestResult]: {
    ID: FIELDS_TYPES.ID,
    NotificationID: FIELDS_TYPES.LOOKUP,
    UserID: FIELDS_TYPES.LOOKUP,
    QuestionsID: FIELDS_TYPES.MULTI_LOOKUP,
    AnswersResult: FIELDS_TYPES.MULTI_LOOKUP,
    Title: FIELDS_TYPES.STRING,
  },
  [notificationTests]: {
    MinCorrectAnswerCount: FIELDS_TYPES.NUMBER,
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Questions: FIELDS_TYPES.MULTI_LOOKUP,
  },
  [notificationTestsQuestion]: {
    ID: FIELDS_TYPES.ID,
    Description: FIELDS_TYPES.STRING,
    Type: FIELDS_TYPES.STRING,
    Answers: FIELDS_TYPES.MULTI_LOOKUP,
    Title: FIELDS_TYPES.STRING,
  },

  [notificationTestsAnswers]: {
    ID: FIELDS_TYPES.ID,
    Description: FIELDS_TYPES.STRING,
    IsCorrect: FIELDS_TYPES.BOOLEAN,
    Title: FIELDS_TYPES.STRING,
  },

  [getNotificationsListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    NotificationID: FIELDS_TYPES.LOOKUP,
    Completed: FIELDS_TYPES.DATE,
    NotificationType: FIELDS_TYPES.LOOKUP,
    ReviewDate: FIELDS_TYPES.DATE,
    Author: FIELDS_TYPES.USER,
    Employee: FIELDS_TYPES.USER,
    EmployeeEmail: FIELDS_TYPES.MULTI_STRING,
    Created: FIELDS_TYPES.DATE,
    Document: FIELDS_TYPES.LOOKUP,
    DocumentCode: FIELDS_TYPES.STRING,
    AuthorComment: FIELDS_TYPES.STRING,
    Test: FIELDS_TYPES.LOOKUP,
    TestedEmployee: FIELDS_TYPES.STRING,
    CheckListID: FIELDS_TYPES.NUMBER,
    Read: FIELDS_TYPES.BOOLEAN,
    Hide: FIELDS_TYPES.BOOLEAN,
    TestAnswerRate: FIELDS_TYPES.NUMBER,
    VersionDocument: FIELDS_TYPES.LOOKUP,
    AuthorEmail: FIELDS_TYPES.STRING,
    TemplateOWDID: FIELDS_TYPES.NUMBER,
    isPass: FIELDS_TYPES.BOOLEAN,
  },
  [sendNotificationsListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    NotificationID: FIELDS_TYPES.LOOKUP,
    Completed: FIELDS_TYPES.DATE,
    NotificationType: FIELDS_TYPES.LOOKUP,
    ReviewDate: FIELDS_TYPES.DATE,
    Author: FIELDS_TYPES.USER,
    Employee: FIELDS_TYPES.USER,
    EmployeeEmail: FIELDS_TYPES.MULTI_STRING,
    Created: FIELDS_TYPES.DATE,
    Document: FIELDS_TYPES.LOOKUP,
    DocumentCode: FIELDS_TYPES.STRING,
    AuthorComment: FIELDS_TYPES.STRING,
    Test: FIELDS_TYPES.LOOKUP,
    TestedEmployee: FIELDS_TYPES.STRING,
    CheckListID: FIELDS_TYPES.NUMBER,
    Read: FIELDS_TYPES.BOOLEAN,
    Hide: FIELDS_TYPES.BOOLEAN,
    TestAnswerRate: FIELDS_TYPES.NUMBER,
    VersionDocument: FIELDS_TYPES.LOOKUP,
    AuthorEmail: FIELDS_TYPES.STRING,
    TemplateOWDID: FIELDS_TYPES.NUMBER,
    isPass: FIELDS_TYPES.BOOLEAN,
  },
  [notificationStatusesListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
  },
  [notificationIdsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [notificationsListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    NotificationID: FIELDS_TYPES.LOOKUP,
    Completed: FIELDS_TYPES.DATE,
    NotificationType: FIELDS_TYPES.LOOKUP,
    ReviewDate: FIELDS_TYPES.DATE,
    Author: FIELDS_TYPES.USER,
    Employee: FIELDS_TYPES.USER,
    EmployeeEmail: FIELDS_TYPES.MULTI_STRING,
    Created: FIELDS_TYPES.DATE,
    PassDate: FIELDS_TYPES.DATE,
    Document: FIELDS_TYPES.LOOKUP,
    DocumentCode: FIELDS_TYPES.STRING,
    AuthorComment: FIELDS_TYPES.STRING,
    Test: FIELDS_TYPES.LOOKUP,
    TestedEmployee: FIELDS_TYPES.MULTI_STRING,
    CheckListID: FIELDS_TYPES.NUMBER,
    Read: FIELDS_TYPES.BOOLEAN,
    Hide: FIELDS_TYPES.BOOLEAN,
    TestAnswerRate: FIELDS_TYPES.NUMBER,
    VersionDocument: FIELDS_TYPES.LOOKUP,
    AuthorEmail: FIELDS_TYPES.MULTI_STRING,
    TemplateOWDID: FIELDS_TYPES.NUMBER,
    isPass: FIELDS_TYPES.BOOLEAN,
  },
  [notificationsCardListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    NotificationID: FIELDS_TYPES.LOOKUP,
    Completed: FIELDS_TYPES.DATE,
    NotificationType: FIELDS_TYPES.LOOKUP,
    ReviewDate: FIELDS_TYPES.DATE,
    Author: FIELDS_TYPES.USER,
    Employee: FIELDS_TYPES.USER,
    EmployeeEmail: FIELDS_TYPES.MULTI_STRING,
    Created: FIELDS_TYPES.DATE,
    PassDate: FIELDS_TYPES.DATE,
    Document: FIELDS_TYPES.LOOKUP,
    DocumentCode: FIELDS_TYPES.STRING,
    AuthorComment: FIELDS_TYPES.STRING,
    Test: FIELDS_TYPES.LOOKUP,
    TestedEmployee: FIELDS_TYPES.STRING,
    CheckListID: FIELDS_TYPES.NUMBER,
    Read: FIELDS_TYPES.BOOLEAN,
    Hide: FIELDS_TYPES.BOOLEAN,
    TestAnswerRate: FIELDS_TYPES.NUMBER,
    VersionDocument: FIELDS_TYPES.LOOKUP,
    AuthorEmail: FIELDS_TYPES.STRING,
    isPass: FIELDS_TYPES.BOOLEAN,
  },
  [templatesOWDListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Questions: FIELDS_TYPES.MULTI_LOOKUP,
    PassRate: FIELDS_TYPES.NUMBER,
    Hide: FIELDS_TYPES.BOOLEAN,
  },
  [checkListOWDIdsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [checkListsOWDListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    AuthorEmail: FIELDS_TYPES.STRING,
    TemplateOWD: FIELDS_TYPES.LOOKUP,
    Comment: FIELDS_TYPES.STRING,
    Rate: FIELDS_TYPES.NUMBER,
    AnswerRate: FIELDS_TYPES.NUMBER,
    Question: FIELDS_TYPES.LOOKUP,
    Answers: FIELDS_TYPES.MULTI_LOOKUP,
    CheckListID: FIELDS_TYPES.NUMBER,
    QuestionType: FIELDS_TYPES.STRING,
    PassRate: FIELDS_TYPES.NUMBER,
  },
  [templateOWDQuestionsListName]: {
    QuestionTitle: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    QuestionType: FIELDS_TYPES.CHOICE,
    TemplateOWD: FIELDS_TYPES.MULTI_LOOKUP,
    Options: FIELDS_TYPES.MULTI_LOOKUP,
    Answers: FIELDS_TYPES.MULTI_LOOKUP,
    QuestionText: FIELDS_TYPES.STRING,
  },
  [templateOWDQuestionListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
};

export type NotificationsListFieldsRecordType = {
  [answersRegistry]: {
    ID: number;
    Description: string;
    IsCorrect: boolean;
    Title: string;
  };
  [questionsRegistry]: {
    ID: number;
    Description: string;
    TypeQuestion: string;
    Answers: LookupFields[];
    Title: string;
  };
  [testRegistry]: {
    ID: number;
    Title: string;
    QuestionsID: LookupFields[];
    Collections: LookupFields;
    MinCorrectAnswerCount: number;
  };
  [notificationTestResult]: {
    ID: number;
    NotificationID: LookupFields;
    UserID: LookupFields;
    QuestionsID: LookupFields[];
    AnswersResult: LookupFields[];
    Title: string;
  };
  [notificationTests]: {
    MinCorrectAnswerCount: number;
    ID: number;
    Title: string;
    Questions: LookupFields[];
  };

  [notificationTestsQuestion]: {
    ID: number;
    Description: string;
    Answers: LookupFields[];
    Type: string;
    Title: string;
  };

  [notificationTestsAnswers]: {
    ID: number;
    Description: string;
    IsCorrect: boolean;
    Title: string;
  };

  [notificationStatusesListName]: {
    Title: string;
    ID: number;
  };

  [getNotificationsListName]: {
    Title: string;
    ID: number;
    Completed: Date;
    NotificationType: LookupFields;
    NotificationID: LookupFields;
    ReviewDate: Date;
    Author: UserFields;
    Created: Date;
    Employee: UserFields;
    EmployeeEmail: string;
    Document: LookupFields;
    DocumentCode: string;
    AuthorComment: string;
    Test: LookupFields;
    TestedEmployee: string;
    CheckListID: number | null;
    Read: boolean;
    Hide: boolean;
    TestAnswerRate: number;
    VersionDocument: LookupFields;
    AuthorEmail: string;
    TemplateOWDID: number;
    isPass: boolean;
  };
  [sendNotificationsListName]: {
    Title: string;
    ID: number;
    Completed: Date;
    NotificationType: LookupFields;
    NotificationID: LookupFields;
    ReviewDate: Date;
    Author: UserFields;
    Created: Date;
    Employee: UserFields;
    EmployeeEmail: string;
    Document: LookupFields;
    DocumentCode: string;
    AuthorComment: string;
    Test: LookupFields;
    TestedEmployee: string;
    CheckListID: number | null;
    Read: boolean;
    Hide: boolean;
    TestAnswerRate: number;
    VersionDocument: LookupFields;
    AuthorEmail: string;
    TemplateOWDID: number;
    isPass: boolean;
  };
  [notificationsListName]: {
    Title: string;
    ID: number;
    Completed: Date;
    NotificationType: LookupFields;
    NotificationID: LookupFields;
    ReviewDate: Date;
    Author: UserFields;
    Created: Date;
    Employee: UserFields;
    EmployeeEmail: string;
    Document: LookupFields;
    DocumentCode: string;
    AuthorComment: string;
    Test: LookupFields;
    TestedEmployee: string;
    CheckListID: number | null;
    Read: boolean;
    Hide: boolean;
    TestAnswerRate: number;
    VersionDocument: LookupFields;
    AuthorEmail: string;
    TemplateOWDID: number;
    isPass: boolean;
  };
  [notificationsCardListName]: {
    Title: string;
    ID: number;
    Completed: Date;
    NotificationType: LookupFields;
    NotificationID: LookupFields;
    ReviewDate: Date;
    Author: UserFields;
    Created: Date;
    Employee: UserFields;
    EmployeeEmail: string;
    Document: LookupFields;
    DocumentCode: string;
    AuthorComment: string;
    Test: LookupFields;
    TestedEmployee: string;
    CheckListID: number;
    Read: boolean;
    Hide: boolean;
    TestAnswerRate: number;
    VersionDocument: LookupFields;
    AuthorEmail: string;
    isPass: boolean;
  };
  [notificationIdsListName]: {
    ID: number;
    Title: string;
  };

  [checkListOWDIdsListName]: {
    ID: number;
    Title: string;
  };
  [checkListsOWDListName]: {
    ID: number;
    Title: string;
    AuthorEmail: string;
    TemplateOWD: LookupFields;
    Comment: string;
    Rate: number;
    AnswerRate: number;
    Question: LookupFields;
    Answers: LookupFields[];
    CheckListID: number;
    QuestionType: string;
    PassRate: number;
  };
  [templatesOWDListName]: {
    ID: number;
    Title: string;
    Questions: LookupFields[];
    PassRate: number;
    Hide: boolean;
  };
  [templateOWDQuestionsListName]: {
    QuestionTitle: string;
    ID: number;
    Title: string;
    QuestionType: "radio" | "select" | "rate";
    TemplateOWD: LookupFields[];
    Options: LookupFields[];
    Answers: LookupFields[];
    QuestionText: string;
  };
  [templateOWDQuestionListName]: {
    ID: number;
    Title: string;
  };
};

export type NotificationsListFieldsType = {
  [questionsRegistry]: {
    ID: number;
    Description: string;
    TypeQuestion: string;
    Answers: LookupFields[];
    Title: string;
  };
  [answersRegistry]: {
    ID: number;
    Description: string;
    IsCorrect: boolean;
    Title: string;
  };
  [testRegistry]: {
    ID: number;
    Title: string;
    QuestionsID: LookupFields[];
    Collections: LookupFields;
    MinCorrectAnswerCount: number;
  };
  [notificationTestResult]: {
    ID: number;
    NotificationID: LookupFields;
    UserID: LookupFields;
    QuestionsID: LookupFields[];
    AnswersResult: LookupFields[];
    Title: string;
  };
  [notificationTests]: {
    MinCorrectAnswerCount: number;
    ID: number;
    Title: string;
    Questions: LookupFields[];
  };
  [notificationTestsQuestion]: {
    ID: number;
    Description: string;
    Answers: LookupFields[];
    Type: string;
    Title: string;
  };
  [notificationTestsAnswers]: {
    ID: number;
    Description: string;
    IsCorrect: boolean;
    Title: string;
  };

  [notificationStatusesListName]: {
    Title: string;
    ID: number;
  };
  [getNotificationsListName]: {
    Title: string;
    ID: number;
    NotificationID: LookUpRecord;
    Completed: Moment;
    NotificationType: LookUpRecord;
    ReviewDate: Date;
    Author: UserRecord;
    Created: Date;
    Employee: UserRecord;
    EmployeeEmail: string;
    Document: LookUpRecord;
    DocumentCode: string;
    AuthorComment: string;
    Test: LookUpRecord;
    TestedEmployee: string;
    CheckListID: number | null;
    Read: boolean;
    Hide: boolean;
    TestAnswerRate: number;
    VersionDocument: LookUpRecord;
    AuthorEmail: string;
    TemplateOWDID: number;
    isPass: boolean;
  };
  [sendNotificationsListName]: {
    Title: string;
    ID: number;
    NotificationID: LookUpRecord;
    Completed: Moment;
    NotificationType: LookUpRecord;
    ReviewDate: Moment;
    Author: UserRecord;
    Created: Moment;
    Employee: UserRecord;
    EmployeeEmail: string;
    Document: LookUpRecord;
    DocumentCode: string;
    AuthorComment: string;
    Test: LookUpRecord;
    TestedEmployee: string;
    CheckListID: number | null;
    Read: boolean;
    Hide: boolean;
    TestAnswerRate: number;
    VersionDocument: LookUpRecord;
    AuthorEmail: string;
    TemplateOWDID: number;
    isPass: boolean;
  };
  [notificationsListName]: {
    Title: string;
    ID: number;
    NotificationID: LookUpRecord;
    Completed: Moment;
    NotificationType: LookUpRecord;
    ReviewDate: Moment;
    Author: UserRecord;
    Created: Moment;
    Employee: UserRecord;
    EmployeeEmail: string;
    Document: LookUpRecord;
    DocumentCode: string;
    AuthorComment: string;
    Test: LookUpRecord;
    TestedEmployee: string;
    CheckListID: number | null;
    Read: boolean;
    Hide: boolean;
    TestAnswerRate: number;
    VersionDocument: LookUpRecord;
    AuthorEmail: string;
    TemplateOWDID: number;
    isPass: boolean;
  };
  [notificationsCardListName]: {
    Title: string;
    ID: number;
    NotificationID: LookUpRecord;
    Completed: Moment;
    NotificationType: LookUpRecord;
    ReviewDate: Moment;
    Author: UserRecord;
    Created: Moment;
    Employee: UserRecord;
    EmployeeEmail: string;
    Document: LookUpRecord;
    DocumentCode: string;
    AuthorComment: string;
    Test: LookUpRecord;
    TestedEmployee: string;
    CheckListID: number;
    Read: boolean;
    Hide: boolean;
    TestAnswerRate: number;
    VersionDocument: LookUpRecord;
    AuthorEmail: string;
    isPass: boolean;
  };
  [notificationIdsListName]: {
    ID: number;
    Title: string;
  };

  [checkListOWDIdsListName]: {
    ID: number;
    Title: string;
  };
  [checkListsOWDListName]: {
    ID: number;
    Title: string;
    AuthorEmail: string;
    TemplateOWD: LookUpRecord;
    Comment: string;
    Rate: number;
    AnswerRate: number;
    Question: LookUpRecord;
    Answers: LookUpRecord[];
    CheckListID: number;
    QuestionType: string;
    PassRate: number;
  };

  [templatesOWDListName]: {
    ID: number;
    Title: string;
    Questions: LookUpRecord[];
    PassRate: number;
    Hide: boolean;
  };
  [templateOWDQuestionsListName]: {
    QuestionTitle: string;
    ID: number;
    Title: string;
    QuestionType: "radio" | "select" | "rate";
    TemplateOWD: LookUpRecord[];
    Options: LookUpRecord[];
    Answers: LookUpRecord[];
    QuestionText: string;
  };
  [templateOWDQuestionListName]: {
    ID: number;
    Title: string;
  };
};
